import { WILLS_V3_9 } from 'lib/@getethos/experiments/constants'
import { useFeatureVariable } from 'lib/FeaturesAndExperiments/getFeatureVariable'

export const WILLS_V3_4_CONTROL_FLOW = 'wills-v3-4-control'
export const WILLS_V3_4_T1_FLOW = 'wills-v3-4-t1'
export const WILLS_V3_4_T2_FLOW = 'wills-v3-4-t2'
export const WILLS_V3_4_T3_FLOW = 'wills-v3-4-t3'
export const WILLS_V3_4_T4_FLOW = 'wills-v3-4-t4'

export const WILLS_V3_6_CONTROL_FLOW = 'wills-v3-6-control'
export const WILLS_V3_6_T3_FLOW = 'wills-v3-6-t3'

export const WILLS_V3_7_T1_FLOW = 'wills-v3-7-t1'
export const WILLS_V3_8_CONTROL_FLOW = 'wills-v3-8-control'
export const WILLS_V3_8_T2_FLOW = 'wills-v3-8-t2'
export const WILLS_V3_9_FLOW = 'wills-v3-9'

export const useWillsFunnelFlow = () => {
  const { isEnabled: isWillsV3_9Enabled, isLoading } = useFeatureVariable(
    WILLS_V3_9.EXPERIMENT_KEY
  )

  let flow
  let isTreatment = false

  if (isWillsV3_9Enabled) {
    flow = WILLS_V3_9_FLOW
    isTreatment = true
  }

  return {
    isLoading,
    isTreatment,
    isLeadForm: false,
    flow,
    controlFlow: WILLS_V3_8_CONTROL_FLOW,
  }
}
